// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3xIOj","header":"ClearentDisclaimer_header__2gdzI","inner":"ClearentDisclaimer_inner__2SgPf"};